export const TEHRAN_TIME_ZONE = 'Asia/Tehran';

const tehranPartsFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: TEHRAN_TIME_ZONE,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hourCycle: 'h23',
});
const pad = (n: number) => String(n).padStart(2, '0');

/** Tehran wall-clock of an instant as a local Date (feed to moment/dayjs/pickers). */
export function toTehranWallClock(date: Date): Date {
  const parts = tehranPartsFormatter.formatToParts(date);
  const part = (t: Intl.DateTimeFormatPartTypes) => Number(parts.find((p) => p.type === t)?.value);
  return new Date(
    part('year'),
    part('month') - 1,
    part('day'),
    part('hour'),
    part('minute'),
    part('second')
  );
}

/** Tehran date + HH:mm[:ss] → UTC ISO with Z. Tehran is fixed +03:30 (no DST). */
export function tehranWallClockToUtc(date: string, time: string): string | undefined {
  const withSeconds = time.length === 5 ? `${time}:00` : time;
  const instant = new Date(`${date}T${withSeconds}+03:30`);
  if (Number.isNaN(instant.getTime())) return undefined;
  return instant.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

/** Today's Tehran day as local Date at 00:00 (picker shape). */
export function getTehranToday(): Date {
  const today = toTehranWallClock(new Date());
  today.setHours(0, 0, 0, 0);
  return today;
}

export function getTehranTodayString(): string {
  const t = getTehranToday();
  return `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())}`;
}

/**
 * Parse an API value for display. Date-only strings (`YYYY-MM-DD`) are anchored at noon UTC
 * so formatting never shifts the day; anything else is parsed as an instant.
 */
export function parseApiDateForDisplay(value: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (match) {
    return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
  }
  return new Date(value);
}
